import React from 'react';

const StatCard = ({ label, value, accent, ghost }) => (
  <div style={{
    background: '#0A1220',
    border: '1px solid rgba(59,111,212,0.15)',
    borderTop: `3px solid ${accent}`,
    padding: '20px 24px',
    position: 'relative',
    overflow: 'hidden',
    flex: 1
  }}>
    <div style={{
      position: 'absolute', bottom: '-12px', right: '-4px',
      fontFamily: '"Arial Black", sans-serif',
      fontSize: '4.5rem', fontWeight: 900,
      color: `rgba(${ghost},0.06)`,
      lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
      letterSpacing: '-0.05em'
    }}>{value}</div>
    <div style={{
      fontFamily: 'monospace', fontSize: '0.48rem',
      letterSpacing: '0.25em', color: 'rgba(238,240,242,0.35)',
      textTransform: 'uppercase', marginBottom: '8px'
    }}>{label}</div>
    <div style={{
      fontFamily: '"Arial Black", sans-serif',
      fontSize: '2.2rem', fontWeight: 900,
      color: '#EEF0F2', letterSpacing: '-0.04em',
      lineHeight: 1
    }}>{value}</div>
  </div>
);

const StatsBar = ({ stats }) => (
  <div style={{
    display: 'flex', gap: '16px',
    marginBottom: '28px',
    flexWrap: 'wrap'
  }}>
    <StatCard label="TOTALT" value={stats?.total ?? 0} accent="#3B6FD4" ghost="59,111,212" />
    <StatCard label="ULEST" value={stats?.unread ?? 0} accent="#E8941A" ghost="232,148,26" />
    <StatCard label="E-POST SAMTYKKE" value={stats?.optinEmail ?? 0} accent="#3B6FD4" ghost="59,111,212" />
    <StatCard label="SMS SAMTYKKE" value={stats?.optinSms ?? 0} accent="#E8941A" ghost="232,148,26" />
  </div>
);

export default StatsBar;
